import { NewButton } from '../index';
import styles from "./InvolvedCards.module.css";
import { tracking } from '../../../../utils/tracking';
import { Link } from 'react-router-dom';

const images = [
   "../../../../assets/events/etvs23/involved-card-3.png",
   "../../../../assets/events/etvs23/involved-card-4.png",
   "../../../../assets/events/etvs23/involved-card-1.png",
   "../../../../assets/events/etvs23/involved-card-2.png",
   "../../../../assets/events/etvs23/involved-card-startup.png",
   "../../../../assets/events/etvs23/involved-card-speaker.png",
   "../../../../assets/events/etvs23/involved-card-partners.png",
   "../../../../assets/events/etvs23/involved-card-press.png"
]

const cards = [
   {
      name: 'Startups',
      content: `Startups showcase their products,\ninnovations, and breakthrough technologies\nto VCs, Corporate VCs, Angel Investors, and\nstrategics looking for their next big deal as a\npart of the Top Innovator Showcase.\n\nApply now, slots are limited!`,
      btnBgColor: 'white',
      btnColor: '#CF1B5B',
      btnTxt: 'APPLY TO PRESENT',
      btnLink: '/events/etvs23/startups',
      btnId: 278
   },
   {
      name: 'Investors',
      content: 'Venture Summit speakers consists of VCs,\nCorporate VCs, and Angel Investors.\n\nSpeak on a venture panel, host a startup\nworkshop, hold Office Hours, or join us as\na VC Judge for the startup pitches.',
      btnBgColor: 'white',
      btnColor: '#CF1B5B',
      btnTxt: 'APPLY TO SPEAK',
      btnLink: '/events/etvs23/speakers',
      btnId: 279
   },
   {
      name: 'Partner with us',
      content: 'Join the ranks of some of the best\nfirms dedicated to working with\nand supporting founders and their\ninvestors.\n\nWe’d love to work with you!',
      btnBgColor: '#CF1B5B',
      btnColor: 'white',
      btnTxt: 'GET MORE INFO',
      btnLink: '/events/etvs23/partners',
      btnId: 280
   },
   {
      name: 'Press',
      content: 'Journalists from any and all \nnationalities, attend the Venture\nSummit to share news of top-level\nspeakers and immersive\ninnovations to the rest of the world.',
      btnBgColor: '#CF1B5B',
      btnColor: 'white',
      btnTxt: 'GET MORE INFO',
      btnLink: '/events/etvs23/press',
      btnId: 281
   },
];

export const InvolvedCards = () => {
   return (
      <div className={styles.involvedCards}>
         <div className={styles.involvedCardsContainer}>
            <h1>Get involved in the <span>Venture Summit</span></h1>
            <div className={styles.iCards}>
               {cards.map((card, i) => {
                  return (
                     <div key={i} className={styles.iCard} style={{
                        backgroundImage: window.innerWidth < 900 ? `url(${images[i + 4]})` : `url(${images[i]})`,
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                     }}>
                        < h5 > {card.name}</h5>
                        <pre>{card.content}</pre>
                        {/* <Link to={card.btnLink} onClick={() => tracking(card.btnId)}>
                           <NewButton
                              name={card.btnTxt}
                              color={card.btnColor}
                              bgColor={card.btnBgColor}
                           />
                        </Link> */}
                        <a href="https://youngstartup.com/upcoming" onClick={() => tracking(card.btnId)}>
                           <NewButton
                              name={card.btnTxt}
                              color={card.btnColor}
                              bgColor={card.btnBgColor}
                           />
                        </a>
                     </div>
                  );
               })}
            </div>
         </div >
      </div >
   );
};
